import useApi from '../useApi';
import axiosInstance from '../axiosInstance';
import { useCallback, useState } from 'react';

export const useGetFooterConfig = (options = {}) => {
  return useApi('/cms/layout/footer-config', {
    method: 'GET',
    ...options,
  });
};

export const useUpdateFooterConfig = (options = {}) => {
  return useApi('/cms/layout/footer-config', {
    method: 'PUT',
    ...options,
  });
};

/**
 * Upload a PDF and get back its URL, so a footer link can point straight at it.
 * Used for the documents published as files rather than pages: terms, traveller
 * rights and the like. Returns the URL and the original file name.
 */
export const useUploadFooterDocument = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const uploadDocument = useCallback(async (file) => {
    setLoading(true);
    setError(null);
    try {
      const formData = new FormData();
      formData.append('document', file);
      const { data } = await axiosInstance.post('/cms/layout/footer-config/document', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      return data?.data ?? null;
    } catch (err) {
      const msg = err.response?.data?.message || 'Failed to upload the document';
      setError(msg);
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  return { loading, error, uploadDocument };
};

export const useUploadFooterBrandLogo = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const uploadLogo = useCallback(async (file) => {
    setLoading(true);
    setError(null);
    try {
      const formData = new FormData();
      formData.append('image', file);
      const { data } = await axiosInstance.post('/cms/layout/footer-config/brand-logo', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      return data?.data?.imageUrl ?? null;
    } catch (err) {
      const msg = err.response?.data?.message || 'Failed to upload footer brand logo';
      setError(msg);
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  return { loading, error, uploadLogo };
};
